<template>
	<div class="pui-form">
		<!--  -->
		<v-form @submit.prevent class="mb-4 pb-4" ref="form" v-model="valid" lazy-validation v-if="modelLoaded">
			<div row wrap class="pui-form-layout">
				<pui-field-set :title="getTitleCheckpoint">
					<v-layout wrap>
						<v-flex xs12 md6>
							<pui-text-field
								:label="$t('checkpoint.checkpointname')"
								v-model="model.checkpointname"
								maxlength="10"
								toplabel
								required
							></pui-text-field>
						</v-flex>
					</v-layout>
					<v-layout wrap>
						<v-flex xs12 md6>
							<pui-text-field
								:label="$t('checkpoint.checkpointlocation')"
								v-model="model.checkpointlocation"
								maxlength="100"
								toplabel
							></pui-text-field>
						</v-flex>
					</v-layout>
					<v-layout wrap>
						<v-flex xs12 md3>
							<pui-date-field
								:label="$t('checkpoint.checkpointfirstuse')"
								v-model="model.checkpointfirstuse"
								toplabel
								:disabled="!isCreatingElement"
							></pui-date-field>
						</v-flex>
						<v-flex xs12 md3>
							<pui-date-field
								:label="$t('checkpoint.checkpointlastuse')"
								v-model="model.checkpointlastuse"
								toplabel
								:disabled="!isCreatingElement"
							></pui-date-field>
						</v-flex>
					</v-layout>
					<v-layout wrap>
						<v-flex xs12 md3>
							<pui-text-field
								:label="$t('checkpoint.checkpointsourceip')"
								v-model="model.checkpointsourceip"
								maxlength="15"
								toplabel
							></pui-text-field>
						</v-flex>
						<v-flex xs12 md3>
							<pui-text-field
								:label="$t('checkpoint.checkpointgui')"
								v-model="model.checkpointgui"
								maxlength="50"
								toplabel
								required
							></pui-text-field>
						</v-flex>
					</v-layout>
					<v-layout wrap>
						<v-flex xs12 md3>
							<pui-number-field
								:label="$t('checkpoint.checkpointlegacyid')"
								v-model="model.checkpointlegacyid"
								maxlength="4"
								toplabel
								:min="0"
							></pui-number-field>
						</v-flex>
					</v-layout>
					<v-layout wrap>
						<v-flex xs12 md3>
							<pui-checkbox
								:label="$t('checkpoint.checkpointactive')"
								v-model="model.checkpointactive"
								true-value="1"
								false-value="0"
							></pui-checkbox>
						</v-flex>
						<v-flex xs12 md3>
							<pui-checkbox
								:label="$t('checkpoint.checkpointusedbyapp')"
								v-model="model.checkpointusedbyapp"
								true-value="1"
								false-value="0"
							></pui-checkbox>
						</v-flex>
					</v-layout>
					<v-layout wrap>
						<v-flex xs12 md3>
							<pui-number-field
								:label="$t('checkpoint.checkpointmajor')"
								v-model="model.checkpointmajor"
								toplabel
								required
								:min="0"
							></pui-number-field>
						</v-flex>
						<v-flex xs12 md3>
							<pui-number-field
								:label="$t('checkpoint.checkpointminor')"
								v-model="model.checkpointminor"
								toplabel
								required
								:min="0"
							></pui-number-field>
						</v-flex>
					</v-layout>
					<v-layout wrap>
						<v-flex xs12 md3>
							<pui-number-field
								:label="$t('checkpoint.checkpointaccuracy')"
								v-model="model.checkpointaccuracy"
								toplabel
								required
								:min="0"
							></pui-number-field>
						</v-flex>
					</v-layout>
				</pui-field-set>
			</div>
			<!-- footer -->
			<pui-form-footer v-if="!isModalDialog">
				<pui-form-footer-btns
					:formDisabled="formDisabled"
					:saveDisabled="saving"
					:saveAndNew="saveAndNew"
					:saveAndUpdate="saveAndUpdate"
					:save="save"
					:back="back"
				></pui-form-footer-btns>
			</pui-form-footer>
		</v-form>
		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import PuiFormMethodsMixin from 'pui9-mixins/PuiFormMethodsMixin';

export default {
	name: 'checkpointform',
	mixins: [PuiFormMethodsMixin],

	data() {
		return {
			modelName: 'checkpoint',
			model: 'checkpoint'
		};
	},
	methods: {},
	computed: {
		getTitleCheckpoint() {
			return this.$t('checkpoint.titlecheckpoint');
		}
	}
};
</script>

<style lang="css" scoped></style>
